import req from '../../api/request'
import type { LinkedTeamRegistration } from '../../features/registration/teamBudgetPayment/types'

/** The fields of a registration session the confirmation step refetches. */
export interface RegistrationSessionSnapshot {
  id: string
  linked_team_registration?: LinkedTeamRegistration | null
  [key: string]: unknown
}

/**
 * The registration session as the server holds it NOW. The wizard's own copy lives
 * in a context that outlives the pay page, so it is stale after a payment.
 */
export const fetchRegistrationSession = async (
  sessionId: string
): Promise<RegistrationSessionSnapshot> => {
  const response = await req(`/registration/session/${sessionId}`)

  return (response?.data ?? response) as RegistrationSessionSnapshot
}
